import { createSelector } from 'reselect';

const getPartnerName = state => state.partnerOwnerAreaReducer.get('partnerName');

export default createSelector(
    [getPartnerName],
    partnerName => ({
        partnerName
    })
);